/**
 * Created by Ning Jiang on 2021-05-27.
 */

import {ReelStopPresentationController} from "../ReelStopPresentationController";
import {IReelStateEventData, ReelState} from "../../../core/reel/ReelState";
import {RockBottomSound} from "../../sound/RockBottomSound";
import {RockBottom} from "../../RockBottom";
import {RockBottomGameMode} from "../../server/RockBottomGameMode";

export class ReelStopSoundController extends ReelStopPresentationController {

    private _spinStates: boolean[];

    constructor() {
        super('ReelStopSoundController');
    }

    public async start(): Promise<any> {
        this._spinStates = RockBottom.reels.map(reel => reel.reelState === ReelState.SPIN);
        await super.start();
    }

    protected onReelBounce(data: IReelStateEventData): Promise<any> {
        const nearWinReels: boolean[] = RockBottom.model.parsedGameData.nearWinReels,
            currReel: number = data.reelId,
            nextReel: number = currReel + 1,
            isBonus: boolean = (RockBottom.model.parsedGameData.mode === RockBottomGameMode.FREESPIN || RockBottom.model.parsedGameData.mode === RockBottomGameMode.SUPER_FREESPIN),
            soundToPlay: string = isBonus ? RockBottomSound.ANTICIPATION_BONUS_MODE_SOUND : RockBottomSound.ANTICIPATION_SOUND,
            soundToEndAnticipation: string = isBonus ? RockBottomSound.ANTICIPATION_BONUS_MODE_END_SOUND : RockBottomSound.ANTICIPATION_END_SOUND,
            nearBigWinReels: boolean[] = RockBottom.model.parsedGameData.nearWinBigWinReels;

        if (currReel >= 1 && currReel <= 3 && nearWinReels[nextReel]) {
            RockBottomSound.fadeMusic(0.5, 12);
            if (!RockBottomSound.soundPlayer.fetchSoundPlayer(soundToPlay)?.isPlaying) {
                RockBottomSound.soundPlayer.playTrack({name: soundToPlay});
            }
        }

        if (currReel >= 2 && currReel <= 4 && nearWinReels[currReel]) {
            RockBottomSound.soundPlayer.playTrack({name: RockBottomSound.ANTICIPATION_REEL_STOP_SOUND});
            if (currReel === 4) {
                if (RockBottom.model.parsedGameData.scatterPositions[currReel] < 0) {
                    RockBottomSound.soundPlayer.stopTrack(soundToPlay);
                    RockBottomSound.soundPlayer.playTrack({name: soundToEndAnticipation});
                    RockBottomSound.fadeMusic(1, 3);
                }
            }

        }

        if (RockBottom.model.parsedGameData.mode === RockBottomGameMode.NORMAL) {
            if (currReel === 3 && nearBigWinReels[4]) {
                RockBottomSound.soundPlayer.playTrack({name: RockBottomSound.PRE_BIGWIN_ANTICIPATION});
            }
            if (currReel === 4 && nearBigWinReels[4]) {
                RockBottomSound.soundPlayer.stopTrack(RockBottomSound.REELS_LANDING);
                RockBottomSound.soundPlayer.playTrack({name: RockBottomSound.ANTICIPATION_REEL_STOP_SOUND});
            }

        }

        if (RockBottom.model.parsedGameData.mode != RockBottomGameMode.NORMAL) {
            if (currReel === 3) {
                if (RockBottomSound.soundPlayer.fetchSoundPlayer(soundToPlay)?.isPlaying) {
                    RockBottomSound.soundPlayer.stopTrack(soundToPlay);
                    RockBottomSound.fadeMusic(1, 3);
                }
            }
        }
        if (currReel === 4) {
            if (RockBottomSound.soundPlayer.fetchSoundPlayer(soundToPlay)?.isPlaying) {
                RockBottomSound.soundPlayer.stopTrack(soundToPlay);
                RockBottomSound.fadeMusic(1, 3);
            }
            RockBottomSound.soundPlayer.stopTrack(RockBottomSound.PRE_BIGWIN_ANTICIPATION);
        }

        this._spinStates[data.reelId] = false;
        if (this._spinStates.every(s => !s)) {
            RockBottomSound.soundPlayer.stopTrack(RockBottomSound.REELS_SPINNING);
        }
        if (!nearWinReels[currReel]) {
            RockBottomSound.soundPlayer.playTrack({name: RockBottomSound.REELS_LANDING});
        }
        return super.onReelBounce(data);
    }

    protected onReelStopped(data: IReelStateEventData): Promise<void> {
        return super.onReelStopped(data);
    }
}